import { css } from "@emotion/react";
import { ReactNode } from "react";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";
import { Level } from "types/code-generator";

interface Props {
  className?: string;
  type?: string;
  size?: string;
  isEmpty?: boolean;
  children?: ReactNode;
}

const subStyles = css`
  background: #999;
`;

const emptyStyles = css`
  background: #ccc;
`;

const smallStyles = css`
  width: 30px;
  height: 30px;
  line-height: 29px;
  font-weight: normal;
  margin: -0.2rem 0;
`;

const lessonsStyles = css`
  background: ${colors.success};
`;

export default function ItemNotification(props: Props) {
  const store = useStore();

  const styles = css`
    float: right;
    background: ${store.isAdminArea || store.user?.level === Level.Instructor
      ? colors.action
      : store.theme.orgColor};
    width: 36px;
    /* padding: 0 0.75rem; */
    height: 36px;
    line-height: 35px;
    border-radius: 18px;
    text-align: center;
    color: #fff;
    margin-left: 1rem;
    ${props.type === "sub" && subStyles};
    ${props.size === "small" && smallStyles};
    ${props.type === "lessons" && lessonsStyles};
    ${props.isEmpty && emptyStyles};
  `;

  return <div css={styles}>{props.children}</div>;
}
